import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {deletePost} from '../../../../services/myAd';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const useRemoveAds = () => {
  const navigate = useNavigate();
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IRemovePostPayload) => {
      return deletePost(payload);
    },
    onSuccess: () => {
      navigate('/profile/my-ads');
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, mutate, isSuccess};
};

export default useRemoveAds;
